import { DirectivesMdl } from './../../components/directives/directives-module';
import { MaterialModule } from './../../material.module';
import { DateInputModule } from './../../components/dateInput/date-input.mdl';
import { ModelInfoModule } from './../../components/model-info/model-info.mdl';
import { FooterEditButtonsMdl } from './../../components/footer-edit-buttons/footer-edit-buttons.mdl';
import { PaginationModule } from './../../components/pagination/pagination.mdl';
import { PanelBoxModule } from './../../components/panel-box/panel-box.mdl';
import { PageHeadingModule } from './../../components/page-heading/page-heading.mdl';
import { ContactCompensationEditDlg } from './contactCompensation/contactCompensation-edit-dlg.cmp';

import { ContactCompensationsList } from './contactCompensations-list.cmp';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContactCompensationsData } from './contactCompensations.data';
//import { TextMaskModule } from 'angular2-text-mask';
import { ContactCompensationDetails } from './contactCompensation/contactCompensation-details.cmp';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PageHeadingModule,
        PanelBoxModule,
        PaginationModule,
        FooterEditButtonsMdl,
        MaterialModule,
        ModelInfoModule,
        DateInputModule,
        DirectivesMdl
    ],
    declarations: [
        ContactCompensationsList,
        ContactCompensationDetails,
        ContactCompensationEditDlg
    ],
    exports: [
        ContactCompensationsList
    ],
    providers: [
        ContactCompensationsData
    ],
    entryComponents: [
        ContactCompensationEditDlg,
    ]
})
export class ContactCompensationsMdl { }



